module.exports = __webpack_public_path__ + "img/EgyptTechChariotArcherS_ua.bbeaf260.webp";